$(function() {
    $('.lazy').lazy({
        //delay: 5000
    });

    /*   UIkit.on('afterready.uk.dom', function(){
            $('.lazy').lazy({
                //delay: 5000
            });
        }); */
});
